const DEFAULT_MAIN_SITE = "https://caf-sports.com";
const DEFAULT_MAIN_SITE_DEV = "http://localhost:3001";

export const IS_LANDING = process.env.REACT_APP_IS_LANDING === "true";

export const LANDING_PAGE_SLUG =
  process.env.REACT_APP_LANDING_PAGE_SLUG || "landing";

/** Production main site URL (build-time). Prefer getMainSiteUrl() for links. */
export const MAIN_SITE_URL =
  process.env.REACT_APP_MAIN_SITE_URL || DEFAULT_MAIN_SITE;

/**
 * URL for "Visit Main Site" links.
 * In local dev, points to the main app on port 3001 unless overridden.
 */
export function getMainSiteUrl() {
  if (process.env.NODE_ENV === "development") {
    const devUrl =
      process.env.REACT_APP_MAIN_SITE_DEV_URL || DEFAULT_MAIN_SITE_DEV;
    if (
      typeof window !== "undefined" &&
      window.location.hostname === "localhost"
    ) {
      return devUrl.replace(/\/+$/, "");
    }
  }

  return MAIN_SITE_URL.replace(/\/+$/, "");
}

export function resolveSiteUrl(fallback = DEFAULT_MAIN_SITE) {
  if (process.env.REACT_APP_SITE_URL) {
    return process.env.REACT_APP_SITE_URL.replace(/\/+$/, "");
  }
  if (typeof window !== "undefined" && window.location.origin) {
    return window.location.origin.replace(/\/+$/, "");
  }
  return fallback.replace(/\/+$/, "");
}
